<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import { GridComponent, ColumnsDirective, ColumnDirective,
  Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport} from '@syncfusion/ej2-vue-grids';
import api from "@/axios";
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
//import Swal from "sweetalert2";
// import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  components: {
    Loader, Layout, PageHeader,
    // Multiselect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  data() {

    return {
      title: "Tiny Pedidos",
      items: [
        {
          text: "Pedidos",
          href: "/"
        },
        {
          text: "Tiny pedidos",
          active: true
        }
      ],
      dataList: null,
      loading: true,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,

      erroPeriodo: '',
      filterSettings: { type: 'Excel' },
      resizeSettings: {
        mode: 'Auto'
      },
      toolbar: [
        // { text: 'Importar Nota Fiscal de Serviço', prefixIcon: 'e-plus', id: 'novoMovServ', align: 'Left' },
        //{ text: 'Criar Nota Fiscal de Serviço', prefixIcon: 'e-plus', id: 'novoMovServ', align: 'Left' },
        { tooltipText: 'Exportar Excel', prefixIcon: 'e-export-excel', id: 'exportExcel', align: 'Left' },
        { tooltipText: 'Exportar CSV', prefixIcon: 'e-export-csv', id: 'exportCsv', align: 'Left' },
        { text: 'Search', tooltipText: 'Pesquisar'}
      ],
    };
  },

  created() {

  },

  mounted() {
    console.log('mounted movtiny-list')
    this.atualizaDataList()
  },

  provide: {
    grid: [Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport]
  },

  methods: {
    recordDoubleClick(evt){
      console.log('recordDoubleClick')
      console.log(evt.rowData.id);
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      let difDias = moment(this.dtFimFiltro).diff(moment(this.dtIniFiltro), 'days')
      if (difDias < 31) {
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
          'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
        }))
        this.showModalPeriodo = false
        this.atualizaDataList()
      } else {
        this.erroPeriodo = 'Diferença entre data inicial e final deve ser menor que 31 dias, caso necessário um período maior favor entrar em contato com suporte.'
      }
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      this.loading = true
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      if (!filtros || !filtros['movdi'] || !filtros['movdf']) {
          let perIniPadrao = moment().startOf('month').format('YYYY-MM-DD')
          let perFimPadrao = moment().endOf('month').format('YYYY-MM-DD')
          this.dtIniFiltro = perIniPadrao
          this.dtFimFiltro = perFimPadrao
          localStorage.setItem('filtros', JSON.stringify({
            'movdi': perIniPadrao,
            'movdf': perFimPadrao,
          }))
        } else {
          this.dtIniFiltro = filtros['movdi']
          this.dtFimFiltro = filtros['movdf']
        }

      // if (!filtros) {
      //   let perIniPadrao = moment(new Date()).startOf('month').format('YYYY-MM-DD')
      //   let perFimPadrao = moment(new Date()).endOf('month').format('YYYY-MM-DD')
      //   this.dtIniFiltro = perIniPadrao
      //   this.dtFimFiltro = perFimPadrao
      //   localStorage.setItem('filtros', JSON.stringify({
      //     'movdi': perIniPadrao,
      //     'movdf': perFimPadrao,
      //   }))
      // } else {
      //   this.dtIniFiltro = filtros['movdi']
      //   this.dtFimFiltro = filtros['movdf']
      // }

      const paramsReq = {
        'di': this.dtIniFiltro,
        'df': this.dtFimFiltro,
      }
      api.get(`${getBaseUrl()}api/indexmovolist`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        console.log(response.data)

        this.dataList = response.data['listMovOlist']
        
        //Formatar dados
        //Formatação datas
        this.dataList.forEach((value) => {
            if (value.datapedido){
                value.datapedido = moment(value.datapedido).format('DD/MM/YYYY')
            } else {
                value.datapedido = '00/00/0000'
            }

            if (value.dataenvio){
                value.dataenvio = moment(value.dataenvio).format('DD/MM/YYYY')
            } else {
                value.dataenvio = '00/00/0000'
            }

            // Lógica para exibir transpname se formaenvio for diferente de MANDAE
            if (value.formaenvio !== 'MANDAE') {
                value.transportadoraExibir = value.transpnome;
            } else {
                value.transportadoraExibir = value.formaenvio;
            }

            if (value.rastreiocod) {
                value.rastreiocodExibir = value.rastreiocod;
            } else {
                value.rastreiocodExibir = 'Sem código';
            }
        })

        this.loading = false
        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
        this.title = `(${this.dataList.length}) Pedidos Tiny: ${dtIniFormated} - ${dtFimFormated}`
      })
      // this.$refs.dataGrid.refresh()
      console.log(this.$refs)
    },

    dataBound: function() {
      this.$refs.dataGrid.autoFitColumns()
    },


    tbClickHandler: function(args) {
      console.log('tbClickHandler')
      console.log(args.item.id)
      this.loading = true

      if (args.item.id === 'exportExcel') {
        const fileProps = {
          fileName: 'PedidosTiny.xlsx'
        }
        this.$refs.dataGrid.excelExport(fileProps)
      }

      else if (args.item.text === 'exportCsv') {
        const fileProps = {
          fileName: 'PedidosTiny.csv'
        }
        this.$refs.dataGrid.csvExport(fileProps)
      }

      this.loading = false
    },


    // rowDataBound: function (args) {
    //   // console.log('row bound args')
    //   // console.log(args)
    //   // const valStatus = args.data["status"]
    //   // args.row.classList.add("sts-"+ valStatus.toLowerCase())
    // },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>
    <Loader v-if="loading" style="min-height: 300px;">
    </Loader>
    <div v-if="!loading">
        <ejs-grid 
                    :dataSource="dataList"
                    ref="dataGrid"
                    :allowFiltering="true"
                    :allowPdfExport="true"
                    :allowResizing="true"
                    :allowExcelExport="true"
                    :allowPaging="true"
                    :resizeSettings="resizeSettings"
                    :filterSettings="filterSettings"
                    :toolbar="toolbar"
                    :recordDoubleClick="recordDoubleClick"
                    :toolbarClick="tbClickHandler"
                    :dataBound="dataBound"
                    :pageSettings="{ pageSizes: ['30', '100', '200', '500', 'All'], pageSize: 30 }"
                    :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                    :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
            <e-columns>
            <!-- Dados Pedidos Tiny -->
                <e-column field="id" headerText="ID" textAlign="Left"></e-column>
                <e-column field="datapedido" headerText="Data Emissão" textAlign="Right" format="dd/mm/yyyy"></e-column>
                <e-column field="status" headerText="Status" textAlign="Right"></e-column>
                <e-column field="numnf" headerText="Número NF-e" textAlign="Left"></e-column>
                <e-column field="olistid" headerText="ID Tiny" textAlign="Right"></e-column>

                <!-- Dados Envio -->
                <e-column field="transportadoraExibir" headerText="Transportadora" textAlign="Right"></e-column>
                <e-column field="valorfrete" headerText="Valor Frete" textAlign="Right"></e-column>
                <e-column field="dataenvio" headerText="Data envio" textAlign="Right"></e-column>
                <e-column field="urltrk" headerText="URL Rastreio" textAlign="Right"></e-column>
                <e-column field="rastreiocodExibir" headerText="Número Rastreio" textAlign="Right"></e-column>
            </e-columns>
      </ejs-grid>
    </div>



    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="perexib">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <b-alert v-if="this.erroPeriodo !== ''"  show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i> {{ erroPeriodo }}
      </b-alert>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<style>

.sts-el {
  background-color: rgba(78,59,0,0.5);
}
.sts-cf {
  background-color: rgba(0,58,78,0.5);
}
.sts-at {
  background-color: rgba(33,78,0,0.5);
}
.sts-ecr {
  background-color: rgba(146,20,0,0.5);
}
.sts-eat {
  background-color: rgba(146,20,0,0.5);
}
.sts-ev {
  background-color: rgba(146,73,0,0.5);
}
</style>